import React from 'react'
import Campaign from './index'
// import '../../App.scss';

const WebCampaigns = () => {
  return (
      <Campaign/>
  )
}

export default WebCampaigns
